var map = {
	"./beian.png": "/xOB",
	"./downloadBtn.png": "WwgV",
	"./downloadERC.png": "Te8c",
	"./logo.png": "+13L"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k8SE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/role ^\.\/.*\.png$
// module id = k8SE
// module chunks = 0